export default [
  {
    path     : "/admin/login",
    name     : "Login",
    meta     : { authRequired: false },
    component: () =>
      import(/* webpackChunkName: "Login" */ "@/pages/Login.vue")
  },
  {
    path     : "/admin",
    name     : "Admin",
    meta     : { authRequired: true },
    component: () =>
      import(
        /* webpackChunkName: "Dashboard" */ "@/pages/admin/AdminTemplate.vue"
        ),
    redirect : "/admin/gateGallery",
    children : [
      {
        path     : "gateGallery",
        name     : "GateGallery",
        component: () =>
          import(
            /* webpackChunkName: "Dashboard" */ "@/pages/GalleryList.vue"
            ),
      },
      {
        path     : "gateGallery/form",
        name     : "GateGalleryForm",
        component: () =>
          import(
            /* webpackChunkName: "Dashboard" */ "@/pages/GalleryForm.vue"
            )
      }
    ]
  }

];
